import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsOutletBlock } from './cms-outlet-block.interface';

export const CMS_COMPONENT_OUTLET_BLOCK_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsOutletBlock.BLOCK_ID,
    block: {
        url: NCmsOutletBlock.BLOCK_ID
    },
    name: 'Outlet block',
    description: 'CMS Outlet block',
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'component',
            default: []
        }
    ]
};
